/**
 * AdSense placeholder component.
 *
 * HOW TO ACTIVATE ADSENSE:
 * 1. Get AdSense approval at https://adsense.google.com
 * 2. Add your AdSense publisher script to public/index.html <head>:
 *      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-XXXXXXXXXX"
 *              crossorigin="anonymous"></script>
 * 3. Replace the placeholder below with a real <ins> tag (see docs/ADSENSE_SETUP.md)
 * 4. Each ad unit needs a unique adSlot ID from your AdSense dashboard
 */

export default function AdSense({ adSlot, adFormat = 'auto', adStyle = {}, label = 'Advertisement' }) {
  // Show placeholder in development or before AdSense approval
  if (process.env.NODE_ENV === 'development' || !adSlot) {
    return (
      <div
        className="flex items-center justify-center border border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800/40 text-gray-400 dark:text-gray-500 text-xs rounded my-4"
        style={{ minHeight: 90, ...adStyle }}
      >
        {label} · Ad placeholder (slot: {adSlot || 'not set'})
      </div>
    );
  }

  // TODO: Replace with real AdSense <ins> tag after approval
  // Example:
  // return (
  //   <ins className="adsbygoogle"
  //        style={{ display: 'block', ...adStyle }}
  //        data-ad-client="ca-pub-XXXXXXXXXX"
  //        data-ad-slot={adSlot}
  //        data-ad-format={adFormat}
  //        data-full-width-responsive="true" />
  // );
  return <div style={{ minHeight: 90, ...adStyle }} />;
}
